<template>
    <v-container app>
        <v-dialog v-model="dialog" persistent max-width="1300px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="#395384" class="white--text" dark v-bind="attrs" v-on="on" @click="addCustumers()">
                    Añadir nuevo cliente
                </v-btn>
                <br />
            </template>

            <template>
                <v-card>
                    <v-toolbar color="#395384" dark flat>
                        <v-toolbar-title>Informacion de cliente</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <template v-slot:extension>
                            <v-tabs v-model="tab" align-with-title fixed-tabs>
                                <v-tabs-slider color="yellow"></v-tabs-slider>

                                <v-tab> Datos de contacto </v-tab>
                                <v-tab> Datos Fiscales </v-tab>
                                <v-tab> Datos Patrimoniales </v-tab>
                                <v-tab> Datos Comerciales </v-tab>
                            </v-tabs>
                        </template>
                    </v-toolbar>

                    <v-tabs-items v-model="tab">
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <v-form ref="form" v-model="valid">
                                        <br />
                                        <v-row>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-text-field v-model="datosClientes.nombres" label="Nombres*" required
                                                    clearable variant="solo-filled" :rules="nameRules"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-text-field v-model="datosClientes.apellidoPaterno"
                                                    label="Apellido Paterno*" required clearable variant="solo-filled"
                                                    :rules="nameRules"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-text-field v-model="datosClientes.apellidoMaterno"
                                                    label="Apellido Materno*" required clearable variant="solo-filled"
                                                    :rules="nameRules"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="datosClientes.telefono" label="Teléfono*" required
                                                    clearable variant="solo-filled" :rules="phoneRules"
                                                    maxlength="10"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="datosClientes.email" label="Email" required clearable
                                                    variant="solo-filled" :rules="emailRules"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="datosClientes.curp" label="CURP" required clearable
                                                    variant="solo-filled" :rules="curpRules" maxlength="18"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="datosClientes.rfc" label="RFC" required clearable
                                                    variant="solo-filled" :rules="rfcRules" maxlength="13"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <br />
                                        <P>Direccion</P>
                                        <v-divider></v-divider>
                                        <br />
                                        <v-row>
                                            <v-col cols="12" sm="3" md="3">
                                                <v-text-field v-model="datosClientes.cruzamiento1" label="Cruzamiento 1*"
                                                    required clearable variant="solo-filled"
                                                    :rules="countriRules"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="3">
                                                <v-text-field v-model="datosClientes.cruzamiento2" label="Cruzamiento 2"
                                                    required clearable variant="solo-filled"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="3"><v-text-field
                                                    v-model="datosClientes.numeroInterior" label="Número Interior*" required
                                                    clearable variant="solo-filled" :rules="countriRules"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3" md="3">
                                                <v-text-field v-model="datosClientes.numeroExterior"
                                                    label="Número Exterior"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field v-model="datosClientes.codigoPostal" label="Código Postal*"
                                                    required clearable variant="solo-filled" :rules="postalCodeRules"
                                                    maxlength="5"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field v-model="datosClientes.pais" label="País" required clearable
                                                    variant="solo-filled" :rules="countriRules"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4"><v-text-field v-model="datosClientes.entidad"
                                                    label="Entidad*" required clearable variant="solo-filled"
                                                    :rules="countriRules"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4"><v-text-field v-model="datosClientes.municipio"
                                                    label="Municipio*" required clearable variant="solo-filled"
                                                    :rules="countriRules"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field v-model="datosClientes.localidad" label="Localidad" required
                                                    clearable variant="solo-filled" :rules="countriRules"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4"><v-text-field v-model="datosClientes.colonia"
                                                    label="Colonia" required clearable variant="solo-filled"
                                                    :rules="countriRules"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-form>

                                    <P>*indicates required field</P>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text> Tab 2 </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text> Tab 3 </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text> Tab 3 </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="ma-2 white--text" color="red accent-4" elevation="4" @click="dialog = false">
                            Close
                        </v-btn>
                        <v-btn class="ma-2 white--text" color="indigo darken-4" variant="flat" elevation="4"
                            @click="(dialog = false), submitForm()" type="submit" :disabled="!valid">
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
        <br />
        <v-divider></v-divider>
        <br />
        <div class="tableCostumers">
            <v-card color="#395384" class="white--text">
                <v-card-title>
                    Clientes
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details
                        solo></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="Customers" :search="search">
                    <template v-slot:item="props">
                        <tr>
                            <td>{{ props.item.nombres }}</td>
                            <td>
                                {{ props.item.apellidoPaterno }}
                                {{ props.item.apellidoMaterno }}
                            </td>
                            <td>{{ props.item.curp }}</td>
                            <td>{{ props.item.rfc }}</td>
                            <td>
                                <v-btn-toggle borderless>
                                    <v-btn @click="updateCustomer(props.item, props.item.id)" outlined>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>

                                    <v-btn @click="deleteCustomer(props.item.id)" outlined>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </div>
    </v-container>
</template>


<script>
import { ref, onUnmounted } from "vue";
import {
    db,
    collection,
    doc,
    deleteDoc,
    setDoc,
    addDoc,
    orderBy,
    query,
    onSnapshot,
} from "../../firebase/index.js";

// crea un nuevo objeto `Date`
var today = new Date();

// obtener la fecha y la hora
var now = today;
// ES6 Modules or TypeScript
import Swal from "sweetalert2";

export default {
    data() {
        return {
            datosClientes: {
                id: "",
                nombres: "",
                apellidoPaterno: "",
                apellidoMaterno: "",
                fechaNacimiento: null,
                curp: "",
                rfc: "",
                telefono: "",
                email: "",
                cruzamiento1: "",
                cruzamiento2: "",
                numeroInterior: "",
                numeroExterior: "",
                codigoPostal: "",
                pais: "",
                entidad: "",
                municipio: "",
                localidad: "",
                colonia: "",
            },
            tab: null,
            valid: true,
            dialog: false,
            notifications: false,
            sound: true,
            widgets: false,
            search: "",
            nameRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => /^[a-zA-Z\s]*$/.test(v) || "Solo se permiten letras",
            ],
            curpRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => (v && v.length >= 17 && v && v.length <= 18) || "CURP inválida",
            ],
            rfcRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => (v && v.length >= 12 && v && v.length <= 13) || "RFC invalida",
            ],
            phoneRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => /^[0-9]{10}$/.test(v) || "Número de teléfono inválido",
            ],
            emailRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Email inválido",
            ],
            postalCodeRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => /^\d{5}$/.test(v) || "Código Postal inválido",
            ],
            countriRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => (v && v.length >= 4) || "Campo requerido",
            ],

            headers: [
                {
                    text: "Nombres",
                    align: "start",
                    sortable: false,
                    value: "nombres",
                },
                { text: "Apellido", value: "apellidoPaterno" },
                { text: "CURP", value: "curp" },
                { text: "RFC", value: "rfc" },
                { text: "Acciones", value: "" },
            ],
            Customers: [],
        };
    },
    methods: {
        addCustumers() {
            console.log("Prueba")
            this.datosClientes = {};
            this.resetForm();

        },
        resetForm() {
            this.nombres = "";
            this.apellidoPaterno = "";
            this.apellidoMaterno = "";
            this.fechaNacimiento = null;
            this.curp = "";
            this.rfc = "";
            this.telefono = "";
            this.email = "";
            this.cruzamiento1 = "";
            this.cruzamiento2 = "";
            this.numeroInterior = "";
            this.numeroExterior = "";
            this.codigoPostal = "";
            this.pais = "";
            this.entidad = "";
            this.municipio = "";
            this.localidad = "";
            this.colonia = "";
            this.$refs.form.resetValidation(); // Resetear la validación del formulario
        },
        submitForm() {
            this.resetForm();
            try {
                if (this.datosClientes.id) {
                    // Update existing customer

                    this.updateCustomer(this.datosClientes);

                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Informacion de cliente actualizada",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    this.dialog = false;
                } else {
                    // Add new customer




                    addDoc(collection(db, "Customers"), {
                        nombres: this.datosClientes.nombres,
                        apellidoPaterno: this.datosClientes.apellidoPaterno,
                        apellidoMaterno: this.datosClientes.apellidoMaterno,
                        fechaNacimiento: null,
                        curp: this.datosClientes.curp,
                        rfc: this.datosClientes.rfc,
                        telefono: this.datosClientes.telefono,
                        email: this.datosClientes.email,
                        cruzamiento1: this.datosClientes.cruzamiento1,
                        cruzamiento2: this.datosClientes.cruzamiento2,
                        numeroInterior: this.datosClientes.numeroInterior,
                        numeroExterior: this.datosClientes.numeroExterior,
                        codigoPostal: this.datosClientes.codigoPostal,
                        pais: this.datosClientes.pais,
                        entidad: this.datosClientes.entidad,
                        municipio: this.datosClientes.municipio,
                        localidad: this.datosClientes.localidad,
                        colonia: this.datosClientes.colonia,
                        date: Date(),
                    })
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Cliente creado con exito",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    this.dialog = false;
                    this.resetForm();
                }

            } catch (error) {
                console.error("Erro al guardar: " + error);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "A ocurrido un error: " + error.message,
                    footer: 'Descuida, intentalo de nuevo o comunicate con tu proveedor',
                });
                console.error("Error en el guardado" + error)

            }
        },
        deleteCustomer(id) {
            this.$swal
                .fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        deleteDoc(doc(db, "Customers", id));
                        this.$swal.fire(
                            "Deleted!",
                            "Your file has been deleted.",
                            "success"
                        );
                    }
                });
        },
        updateCustomer(item) {
            this.dialog = true;
            this.datosClientes = { ...item };
            console.log("UpdateCustomer" + item)
            setDoc(doc(db, "Customers", item.id), {
                nombres: item.nombres,
                apellidoPaterno: item.apellidoPaterno,
                apellidoMaterno: item.apellidoMaterno,
                fechaNacimiento: null,
                curp: item.curp,
                rfc: item.rfc,
                telefono: item.telefono,
                email: item.email,
                cruzamiento1: item.cruzamiento1,
                cruzamiento2: item.cruzamiento2,
                numeroInterior: item.numeroInterior,
                numeroExterior: item.numeroExterior,
                codigoPostal: item.codigoPostal,
                pais: item.pais,
                entidad: item.entidad,
                municipio: item.municipio,
                localidad: item.localidad,
                colonia: item.colonia,
                date: Date(),
            });


        },
    },
    mounted() {
        const latestQuery = query(collection(db, "Customers"), orderBy("date"));
        this.liveCustomers = onSnapshot(latestQuery, (snapshot) => {
            this.Customers = snapshot.docs.map((doc) => ({
                id: doc.id,
                nombres: doc.data().nombres,
                apellidoPaterno: doc.data().apellidoPaterno,
                apellidoMaterno: doc.data().apellidoMaterno,
                fechaNacimiento: null,
                curp: doc.data().curp,
                rfc: doc.data().rfc,
                telefono: doc.data().telefono,
                email: doc.data().email,
                cruzamiento1: doc.data().cruzamiento1,
                cruzamiento2: doc.data().cruzamiento2,
                numeroInterior: doc.data().numeroInterior,
                numeroExterior: doc.data().numeroExterior,
                codigoPostal: doc.data().codigoPostal,
                pais: doc.data().pais,
                entidad: doc.data().entidad,
                municipio: doc.data().municipio,
                localidad: doc.data().localidad,
                colonia: doc.data().colonia,
            }));
        });
    },
};
</script> 

  